/**
 * Component used to fix SVG elements that wrap a <use> element (which reference
 * external SVG sprites) and are rendered on Microsoft Edge within an iframe.
 *
 * Bugs:
 * - https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8323875/
 * - https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/9655192/
 *
 * How to use it:
 * This:
 * <svg>
 *     <use xlinkHref="http://host/sprite.svg#beautiful-icon">
 * </use>
 *
 * becomes:
 * <SvgIcon src="http://host/sprite.svg" id="beautiful-icon" />
 */

import classNames from "classnames";
import PropTypes from "prop-types";
import React, { Component } from "react";
import request from "superagent";
import {
    createSanitizedMarkup,
    getInnerHtmlOfSvgElement,
    isEdgeBrowser,
    isInIframe,
    isInternetExplorer11,
} from "../../utils/Utils";

const { DOMParser } = window;

class SvgIcon extends Component {
    constructor() {
        super();

        this.shouldFixIconWhenInIframe = (isEdgeBrowser() || isInternetExplorer11()) && isInIframe();
        this.state = {
            spriteMarkup: "",
            viewBox: "0 0 0 0",
        };
    }

    componentWillMount() {
        if (this.shouldFixIconWhenInIframe) {
            this.loadSvgIcon();
        }
    }

    loadSvgIcon() {
        request.get(this.props.src).end((error, response) => {
            if (error) {
                console.log(error); // eslint-disable-line no-console
            } else {
                const parser = new DOMParser();
                const svgDom = parser.parseFromString(response.text, "image/svg+xml");
                const svgElement = svgDom.getElementById(this.props.id);

                this.setState({
                    spriteMarkup: getInnerHtmlOfSvgElement(svgElement),
                    viewBox: svgElement.getAttribute("viewBox"),
                });
            }
        });
    }

    render() {
        const { src, id } = this.props;
        const { spriteMarkup, viewBox } = this.state;
        const svgIconClassNames = classNames("svg-icon", this.props.className);

        /*
         * Microsoft Edge won't play nice (as in it won't render at all) if we
         * update and SVG element's markup after it was already mounted into the
         * DOM. That's why we need to wait for the markup before we actually
         * render the SVG element. Nice Easter egg, if you ask me. :)
         */
        if (this.shouldFixIconWhenInIframe && !spriteMarkup) {
            return null;
        }

        return this.shouldFixIconWhenInIframe ? (
            <svg
                className={svgIconClassNames}
                dangerouslySetInnerHTML={createSanitizedMarkup(spriteMarkup)}
                viewBox={viewBox}
            />
        ) : (
            <svg className={svgIconClassNames}>
                <use xlinkHref={`${src}#${id}`} />
            </svg>
        );
    }
}

SvgIcon.propTypes = {
    src: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    className: PropTypes.string,
};

SvgIcon.defaultProps = {
    className: "",
};

export default SvgIcon;
